import PageHero from "../components/PageHero";
import CtaBanner from "../components/CtaBanner";
import QuoteForm from "../components/QuoteForm";
import { Reveal } from "../components/Reveal";
import { snowImages } from "../data/site";

const blocks = [
  {
    heading: "Our Story",
    body: "We take pride in ensuring that our clients' outdoor spaces look maintained during every season of the year. Our goal is to take all the dread and work of dealing with snow in our winter seasons into our hands and out of your mind.",
    image: snowImages.plow,
  },
  {
    heading: "Our Services",
    body: "Our team provides reliable services including residential snow clearing, large-scale commercial snow removal, professional plowing, and sanding to improve traction and safety during icy conditions. With the right equipment and a hardworking team, we're able to respond quickly to snowfall and keep driveways, parking lots, and walkways clear. At Fresh Landscaping, our goal is simple: deliver dependable service and peace of mind so our clients know their property is taken care of no matter the weather.",
    image: snowImages.clearing,
  },
  {
    heading: "Our Team",
    body: "Our team consists of highly trained and experienced professionals who are passionate about what they do and are willing to work around the clock to ensure safety and a consistent product every day of the week. We are committed to providing our customers with the best possible service and ensuring their complete satisfaction.",
    image: snowImages.trucks,
  },
];

const SnowRemoval = () => (
  <div data-testid="snow-removal-page">
    <PageHero
      overline="Snow Removal"
      title="Fresh Landscaping snow services."
      subtitle="Reliable residential & commercial snow removal in Airdrie and across Alberta — plowing, clearing and sanding."
      image={snowImages.trucks}
    />

    {blocks.map((b, i) => (
      <section key={b.heading} className={`py-20 md:py-28 ${i % 2 === 0 ? "bg-bone" : "bg-sand"}`}>
        <div className={`container-fl grid md:grid-cols-12 gap-12 md:gap-16 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}>
          <Reveal className="md:col-span-6 [direction:ltr]">
            <p className="overline mb-5">{b.heading}</p>
            <p className="font-serif text-2xl md:text-3xl text-ink leading-snug">{b.body}</p>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-6 [direction:ltr]">
            <img src={b.image} alt={b.heading} className="w-full aspect-[4/3] object-cover" />
          </Reveal>
        </div>
      </section>
    ))}

    <section className="py-24 md:py-28 bg-forest-deep text-bone">
      <div className="container-fl grid md:grid-cols-12 gap-14">
        <Reveal className="md:col-span-5">
          <p className="overline text-clay mb-5">For all your snow removal needs</p>
          <h2 className="text-4xl md:text-5xl text-bone leading-tight">Book before the first snowfall.</h2>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-7 bg-white p-8 md:p-12">
          <QuoteForm defaultService="Snow Removal" />
        </Reveal>
      </div>
    </section>

    <CtaBanner title="Peace of mind, all winter long." />
  </div>
);

export default SnowRemoval;
